import { Outlet } from 'react-router-dom';
import { ContactRound, GraduationCap, Layers, Sparkles, VenetianMask } from 'lucide-react';
import type { MenuItemsType } from '@duke-hq/ui/components/SubSidebar/MenuItems';
import { SidebarLayout } from '@duke-hq/ui/components/SubSidebar/SidebarLayout';
import { t } from '@lingui/core/macro';
import { withPermission } from '../withPermission';
import { useCheckPermission } from '../hooks';

export const UnitsLayout = withPermission('canManageCourseContent', () => {
  const canAccessAIGeneration = useCheckPermission('canAccessAIContentGeneration');

  const items: MenuItemsType[] = [
    {
      label: t`Units`,
      link: `/units`,
      icon: Layers,
      showDivider: !canAccessAIGeneration,
    },
    ...(canAccessAIGeneration
      ? [
          {
            label: t`Content Generation`,
            link: `/units/generation`,
            icon: Sparkles,
            showDivider: true,
            criteria: ['_'],
          },
        ]
      : []),
    {
      label: t`Roles`,
      link: `/units/content-roles`,
      icon: GraduationCap,
    },
    {
      label: t`Personas`,
      link: `/units/content-personas`,
      icon: VenetianMask,
    },
    {
      label: t`Profiles`,
      link: `/units/content-profiles`,
      icon: ContactRound,
    },
  ];

  return (
    <SidebarLayout items={items} label={t`Units`} showCollapseButton={false}>
      <Outlet />
    </SidebarLayout>
  );
});
